import React from 'react';
import { Card, Button, Grid, Page, Site } from 'tabler-react';
import logo from '../../assets/images/logo.png';
import Loading from '../../Components/Loading';
import fetch from '../../support/fetch';

class FreeActivation extends React.Component {

    state = {
        isSuccessful: false,
        code: "",
        isError: false,
        loading: false
    };

    componentDidMount() {
        const {match} = this.props;
        this.setState({code: match.params.code});
    }

    sendConfirmFreeActivation = () =>{
        this.setState({
            loading: true
        });
        fetch.obj({
            query: `mutation CreateNewFreeSubscription($code: String!) {
                newFreeSubscription(code: $code) {
                    id
                }
            }`,
            variables: {
                code: this.state.code || "",
            }
        })
        .then(res => {
            this.setState({
                loading: false
            });
            if (res.errors) {
                this.setState({
                    isSuccessful: false,
                    isError: true
                });
            }
            if (res.data.newFreeSubscription && res.data.newFreeSubscription.hasOwnProperty('id')) {
                this.setState({
                    isSuccessful: true
                });   
            }
            
        });

    };

    render() {
        return(
            <Page>
                <Page.Main>
                    <Site.Header>
                        <Site.Logo src={logo} href="/home" alt="Account | Ooppah" />

                    </Site.Header>

                    <Page.Content>
                        <div style={{minHeight: "70vh"}} >
                            <Grid>
                                <Grid.Row>
                                    <Grid.Col>

                                        { (this.state.loading) &&
                                            <Loading />
                                        }
                                        { (this.state.isError) && 
                                            <Card>
                                                <Card.Alert color="danger" className="text-center">
                                                    <strong>Ocorreu algum erro! Entre em contato com o nosso suporte para mais informações.</strong>
                                                </Card.Alert>
                                            </Card>
                                        }
                                        { (!this.state.isSuccessful && !this.state.isError && !this.state.loading) && 
                                            <Card>
                                                <Card.Title className="p-5">
                                                    <span>Você pode reativar sua assinatura como gratuita utilizando essa página. Com apenas um clique, sua conta volta para nossas pesquisas e pode ser encontrada por pesquisadores e produtores.</span>
                                                </Card.Title>

                                                <Card.Body>
                                                    <span>Deseja ativar sua conta como perfil gratuito?</span><br></br>
                                                    <Button color="primary"onClick={this.sendConfirmFreeActivation} >Ativar</Button>
                                                </Card.Body>
                                            </Card>
                                        }

                                        { this.state.isSuccessful && 
                                            <Card>
                                                <Card.Title className="p-5">
                                                    <span>Sua conta foi ativada!</span>
                                                </Card.Title>

                                                <Card.Body>
                                                    <span>
                                                        Pronto! Você já está de volta ao Ooppah! 😃 <br></br>
                                                        Aproveite pra atualizar suas fotos e vídeos! <br></br>
                                                        O Ooppah ajuda você a se apresentar da melhor forma! 👉🏻<a href='https://www.store.ooppah.com/boxestrela2/prod-9389658/'> Clique aqui </a>  <br></br>
                                                    </span>
                                                </Card.Body>
                                            </Card>
                                        }
                                        
                                    </Grid.Col>

                                </Grid.Row>
                            </Grid>
                        </div>
                    </Page.Content>

                    <footer className="footer">
                        <div className="container">
                            <div className="row align-items-center flex-row-reverse">
                                <div className="col-auto ml-lg-auto">
                                    <div className="row align-items-center">
                                        <div className="col-auto">
                                            <ul className="list-inline list-inline-dots mb-0">
                                                <li className="list-inline-item"><a href="https://www.ooppah.com.br" target="_blank">Site</a></li>
                                                {/*<li className="list-inline-item"><a href="https://www.ooppah.com.br/backend" target="_blank">Backend</a></li>*/}
                                                <li className="list-inline-item"><a href="https://ooppah.zendesk.com/hc/pt-br" target="_blank">Suporte</a></li>
                                            </ul>
                                        </div>
                                        <div className="col-auto">
                                            <a href="https://github.com/zabaala" target="_blank" className="btn btn-outline-primary btn-sm">
                                                With <span className="text-red">❤</span> by @zabaala
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-auto mt-3 mt-lg-0">
                                    Account é um produto <a href=".">Ooppah.com</a>.<br />
                                    Copyright © 2016-2019 | Todos os direitos reservados.
                                </div>
                            </div>
                        </div>
                    </footer>
                </Page.Main>
            </Page>

        );

    }
}

export default FreeActivation;